module.exports = __webpack_public_path__ + "static/media/delete-icon.c2361e13.svg";